module.exports = __webpack_public_path__ + "img/bg2.287f9969.png";